import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { bucketApi } from '../services/api';

/*
 * 버킷리스트 — 하고 싶은 일을 카테고리와 함께 적고, 이루면 체크한다.
 * 이룬 것은 아래로 내려가고 언제 이뤘는지 날짜가 남는다.
 * 카테고리마다 FOLD_AT 개까지만 보이고 나머지는 "더 보기" 로 접어 둔다.
 */

// 서버(LedgerService.BUCKET_CATEGORIES)와 같은 이름·순서.
const CATEGORIES = [
  { key: '먹을거', emoji: '🍜' },
  { key: '데이트', emoji: '💕' },
  { key: '혼자', emoji: '🎧' },
  { key: '엄마아빠', emoji: '👨‍👩‍👧' },
];
// 카테고리가 생기기 전에 적은 것들.
const UNSORTED = { key: '', emoji: '📌', label: '미분류' };
const FOLD_AT = 5;

const catOf = (key) => CATEGORIES.find((c) => c.key === key) || UNSORTED;
const catLabel = (c) => c.label || c.key;

const Wrap = styled.div`
  max-width: 640px;
  padding-bottom: 40px;

  h2 {
    margin: 0 0 4px;
    font-size: 1.5rem;
    color: #333;
  }
`;

const Progress = styled.p`
  margin: 0 0 18px;
  color: #888;
  font-size: 0.92rem;

  strong { color: #007bff; }
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: ${(p) => p.$gap || '10px'};
`;

const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 11px;
  border: 1px solid ${(p) => (p.$on ? '#007bff' : '#ddd')};
  border-radius: 999px;
  background: ${(p) => (p.$on ? '#e8f1ff' : '#fff')};
  color: ${(p) => (p.$on ? '#0056b3' : '#555')};
  font-size: 0.9rem;
  font-weight: ${(p) => (p.$on ? 600 : 400)};
  cursor: pointer;
  white-space: nowrap;

  .n {
    font-size: 0.78rem;
    color: ${(p) => (p.$on ? '#007bff' : '#aaa')};
    font-variant-numeric: tabular-nums;
  }
`;

const AddBox = styled.div`
  margin-bottom: 22px;
  padding: 12px;
  border: 1px solid #eee;
  border-radius: 10px;
  background: #fafbfc;

  .label {
    margin: 0 0 8px;
    font-size: 0.82rem;
    color: #888;
  }
`;

const AddRow = styled.form`
  display: flex;
  gap: 8px;

  input {
    flex: 1;
    min-width: 0;
    padding: 11px 13px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 1rem;
  }
  input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.12);
  }
  button {
    flex: none;
    padding: 0 18px;
    border: none;
    border-radius: 8px;
    background: #007bff;
    color: #fff;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
  }
  button:disabled { opacity: 0.5; cursor: default; }
`;

const Section = styled.section`
  margin-bottom: 22px;

  h3 {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin: 0 0 6px;
    font-size: 1.05rem;
    color: #333;
  }
  h3 .count {
    font-size: 0.8rem;
    font-weight: 400;
    color: #999;
    font-variant-numeric: tabular-nums;
  }
  .none {
    margin: 0;
    padding: 10px 4px;
    border-top: 1px solid #eee;
    color: #bbb;
    font-size: 0.88rem;
  }
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  border-top: 1px solid #eee;
`;

const FoldButton = styled.button`
  display: block;
  width: 100%;
  padding: 10px 0;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  background: none;
  color: #007bff;
  font-size: 0.88rem;
  cursor: pointer;

  &:hover { background: #f7faff; }
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 4px;
  border-bottom: 1px solid #f0f0f0;

  label {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
  }
  .cat {
    position: relative;
    flex: none;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.05rem;
    opacity: ${(p) => (p.$done ? 0.5 : 1)};
  }
  .cat:hover { background: #f2f2f2; }
  /* 이모지 위에 투명한 select 를 겹쳐 둔다 — 누르면 휴대폰 기본 선택창이 뜬다. */
  .cat select {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  input[type='checkbox'] {
    flex: none;
    width: 20px;
    height: 20px;
    accent-color: #007bff;
    cursor: pointer;
  }
  .title {
    flex: 1;
    min-width: 0;
    font-size: 1rem;
    color: ${(p) => (p.$done ? '#aaa' : '#333')};
    text-decoration: ${(p) => (p.$done ? 'line-through' : 'none')};
    overflow-wrap: anywhere;
  }
  .when {
    flex: none;
    font-size: 0.78rem;
    color: #2e7d32;
    font-variant-numeric: tabular-nums;
  }
  .del {
    flex: none;
    border: none;
    background: none;
    padding: 6px;
    border-radius: 6px;
    color: #c8c8c8;
    line-height: 0;
    cursor: pointer;
  }
  .del:hover { color: #c62828; background: #fdeaea; }
`;

const Empty = styled.p`
  padding: 36px 0;
  text-align: center;
  color: #aaa;
`;

const ErrorText = styled.p`
  color: #c62828;
  font-size: 0.9rem;
  margin: -8px 0 14px;
`;

function TrashIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 6h18" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  );
}

/** 아직 못 이룬 것이 위, 이룬 것이 아래. 각각은 적은 순서대로(서버와 같은 규칙). */
const sortItems = (items) =>
  [...items].sort(
    (a, b) => Number(a.done) - Number(b.done) || (a.created_at || '').localeCompare(b.created_at || ''),
  );

/** "2026-10-26" → "26.10.26" */
const shortDate = (s) => (s ? `${s.slice(2, 4)}.${s.slice(5, 7)}.${s.slice(8, 10)}` : '');

function BucketList() {
  const [items, setItems] = useState(null);
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState(null); // 새로 적을 것의 카테고리
  const [filter, setFilter] = useState('all'); // 'all' 이거나 카테고리 이름
  const [open, setOpen] = useState({}); // 펼친 카테고리 { [key]: true }
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    bucketApi
      .getAll()
      .then((res) => setItems(res.data || []))
      .catch(() => {
        setItems([]);
        setError('버킷리스트를 불러오지 못했습니다.');
      });
  }, []);

  const add = async (e) => {
    e.preventDefault();
    const text = title.trim();
    if (!text) return;
    if (!category) {
      setError('카테고리를 골라 주세요.');
      return;
    }
    setAdding(true);
    setError(null);
    try {
      const res = await bucketApi.create(text, category);
      setItems((prev) => sortItems([...(prev || []), res.data]));
      setTitle('');
      inputRef.current?.focus(); // 연달아 적는 경우가 많다
    } catch (err) {
      setError(err.response?.data?.detail || '추가하지 못했습니다.');
    } finally {
      setAdding(false);
    }
  };

  const toggle = async (item) => {
    const before = items;
    // 눌렀을 때 바로 체크되어 보이게 먼저 바꾸고, 실패하면 되돌린다.
    setItems((prev) => sortItems(prev.map((it) => (it.id === item.id ? { ...it, done: !it.done } : it))));
    try {
      const res = await bucketApi.setDone(item.id, !item.done);
      setItems((prev) => sortItems(prev.map((it) => (it.id === item.id ? res.data : it))));
    } catch (err) {
      setItems(before);
      setError('저장하지 못했습니다. 다시 시도해 주세요.');
    }
  };

  const changeCategory = async (item, next) => {
    if (next === item.category) return;
    const before = items;
    setItems((prev) => prev.map((it) => (it.id === item.id ? { ...it, category: next } : it)));
    try {
      const res = await bucketApi.setCategory(item.id, next);
      setItems((prev) => prev.map((it) => (it.id === item.id ? res.data : it)));
    } catch (err) {
      setItems(before);
      setError('카테고리를 바꾸지 못했습니다.');
    }
  };

  const pickFilter = (key) => {
    setFilter(key);
    if (key !== 'all') setCategory(key); // 그 카테고리를 보면서 적으면 거기로 들어가게
  };

  const remove = async (item) => {
    if (!window.confirm(`「${item.title}」을(를) 지울까요?`)) return;
    try {
      await bucketApi.delete(item.id);
      setItems((prev) => prev.filter((it) => it.id !== item.id));
    } catch (err) {
      setError('지우지 못했습니다.');
    }
  };

  const all = items || [];
  const doneCount = all.filter((it) => it.done).length;
  const countOf = (key) => all.filter((it) => (it.category || '') === key).length;

  // 전체 보기에서는 카테고리마다 한 덩어리. 미분류는 있을 때만.
  const groups = (filter === 'all' ? [...CATEGORIES, UNSORTED] : [catOf(filter)])
    .map((c) => ({ cat: c, list: all.filter((it) => (it.category || '') === c.key) }))
    .filter((g) => g.cat !== UNSORTED || g.list.length > 0);

  const renderItem = (it) => {
    const cat = catOf(it.category);
    return (
      <Item key={it.id} $done={it.done}>
        <span className="cat" title={`${catLabel(cat)} — 눌러서 카테고리 바꾸기`}>
          <span aria-hidden="true">{cat.emoji}</span>
          <select
            value={it.category || ''}
            aria-label={`${it.title} 카테고리 바꾸기`}
            onChange={(e) => changeCategory(it, e.target.value)}
          >
            {!it.category && <option value="">{UNSORTED.emoji} 미분류</option>}
            {CATEGORIES.map((c) => (
              <option key={c.key} value={c.key}>
                {c.emoji} {c.key}
              </option>
            ))}
          </select>
        </span>
        <label>
          <input type="checkbox" checked={it.done} onChange={() => toggle(it)} />
          <span className="title">{it.title}</span>
          {it.done && it.done_at && <span className="when">{shortDate(it.done_at)} 이룸</span>}
        </label>
        <button className="del" onClick={() => remove(it)} title="지우기" aria-label={`${it.title} 지우기`}>
          <TrashIcon />
        </button>
      </Item>
    );
  };

  const renderGroup = ({ cat, list }) => {
    const key = cat.key || '_unsorted';
    const expanded = !!open[key];
    const shown = expanded ? list : list.slice(0, FOLD_AT);
    const hidden = list.length - shown.length;
    const done = list.filter((it) => it.done).length;
    return (
      <Section key={key} aria-label={catLabel(cat)}>
        <h3>
          <span aria-hidden="true">{cat.emoji}</span> {catLabel(cat)}
          {list.length > 0 && <span className="count">{done}/{list.length}</span>}
        </h3>
        {list.length === 0 ? (
          <p className="none">아직 없어요.</p>
        ) : (
          <List>
            {shown.map(renderItem)}
            {(hidden > 0 || expanded) && list.length > FOLD_AT && (
              <li>
                <FoldButton type="button" onClick={() => setOpen((o) => ({ ...o, [key]: !expanded }))}>
                  {expanded ? '접기 ▲' : `${hidden}개 더 보기 ▼`}
                </FoldButton>
              </li>
            )}
          </List>
        )}
      </Section>
    );
  };

  return (
    <Wrap>
      <h2>버킷리스트</h2>
      <Progress>
        {all.length > 0 ? (
          <>
            {all.length}개 중 <strong>{doneCount}개</strong> 이뤘어요
          </>
        ) : (
          '하고 싶은 일을 하나씩 적어 보세요.'
        )}
      </Progress>

      <AddBox>
        <p className="label">어떤 버킷리스트인가요?</p>
        <Chips role="radiogroup" aria-label="추가할 카테고리">
          {CATEGORIES.map((c) => (
            <Chip
              key={c.key}
              type="button"
              role="radio"
              aria-checked={category === c.key}
              $on={category === c.key}
              onClick={() => {
                setCategory(c.key);
                setError(null);
                inputRef.current?.focus();
              }}
            >
              <span aria-hidden="true">{c.emoji}</span>
              {c.key}
            </Chip>
          ))}
        </Chips>
        <AddRow onSubmit={add}>
          <input
            ref={inputRef}
            value={title}
            maxLength={200}
            placeholder="예: 오로라 보러 가기"
            aria-label="버킷리스트에 추가할 일"
            onChange={(e) => setTitle(e.target.value)}
          />
          <button type="submit" disabled={adding || !title.trim()}>
            {adding ? '추가 중…' : '추가'}
          </button>
        </AddRow>
      </AddBox>

      {error && <ErrorText>{error}</ErrorText>}

      <Chips $gap="18px" aria-label="카테고리별로 보기">
        <Chip type="button" $on={filter === 'all'} aria-pressed={filter === 'all'} onClick={() => pickFilter('all')}>
          전체 <span className="n">{all.length}</span>
        </Chip>
        {CATEGORIES.map((c) => (
          <Chip
            key={c.key}
            type="button"
            $on={filter === c.key}
            aria-pressed={filter === c.key}
            onClick={() => pickFilter(c.key)}
          >
            <span aria-hidden="true">{c.emoji}</span>
            {c.key} <span className="n">{countOf(c.key)}</span>
          </Chip>
        ))}
      </Chips>

      {items === null ? <Empty>불러오는 중…</Empty> : groups.map(renderGroup)}
    </Wrap>
  );
}

export default BucketList;
